import { AxiosInstance } from 'axios'

export type DeleteUserProfileImageParams = {
  userId: string
}

export type DeleteUserProfileImageResponse = Record<string, string>

type DeleteUserProfileImage = (
  apiClient: AxiosInstance,
  params: DeleteUserProfileImageParams
) => Promise<DeleteUserProfileImageResponse>

export const deleteUserProfileImage: DeleteUserProfileImage = async (
  apiClient,
  { userId }
) => {
  const { data } = await apiClient.delete(`/api/users/${userId}/picture`)

  return data.data
}
